import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import Logo from '../../../assets/images/startup/LogoExitfund.svg'
import Bell from '../../../assets/images/startup/bell.svg'
import NoNotification from '../../../assets/images/no-notification.png'
import { Badge, Row, Col, Spin, Avatar, Popover } from 'antd'
import ProfileToggle from '../../../pages/StartupApprovedPortal/StartupApprovedProfile/ProfileToggle'
import {
  fetchUnreadNotifications,
  clearAllNotification,
} from '../../../redux/startupApprovedFlowControl/StratupApprovedFlowControlActions'
import { fetchProfileData } from '../../../redux/trackingFlowControl/TrackingFlowControlActions'
import './HeaderStartupApprovedMobile.scss'

// Startup approved header for mobile view
const HeaderStartupApprovedMobile = props => {
  const [unread, setUnread] = useState(0)
  const { unread_notification_count, unread_notifications, notificationLoader } = useSelector(
    state => state.StratupApprovedFlowControlReducers,
  )
  const { profile_data } = useSelector(state => state.trackingFlowControlReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    if (Object.keys(profile_data).length == 0) {
      dispatch(fetchProfileData())
    }
  }, [profile_data])

  // Update unread count when unread_notification_count changes
  useEffect(() => {
    setUnread(unread_notification_count)
  }, [unread_notification_count])

  // Handle visibility change
  const VisibleChangeHandler = visiblity => {
    if (!visiblity) {
      setUnread(0)
    }
  }

  // Handle notification click & fetch unread notifications
  const onNotificationClick = () => {
    dispatch(fetchUnreadNotifications())
  }

  // Handle clear all notifications
  const onClearNotification = () => {
    dispatch(clearAllNotification())
  }

  // Notifications component for notifications toggle
  const notifications = (
    <div
      className={`approved-notifications-content-wrapper ${
        unread_notifications?.length === 0 || unread_notifications?.data?.length == 0 ? 'no-data' : ''
      }`}
    >
      <>
        <div className="pop-header">
          <h4>Notification</h4>
          {!notificationLoader && (!unread_notifications || unread_notifications?.data?.length > 0) && (
            <span className="clear-all" onClick={() => onClearNotification()}>
              Clear all
            </span>
          )}
        </div>
        {notificationLoader ? (
          <Spin />
        ) : unread_notifications?.data?.length > 0 ? (
          <>
            <div className="pop-content">
              {unread_notifications?.data?.map(item => (
                <div className="line-hr">
                  <Row gutter={12}>
                    <Col span={24}>
                      <div className="alignments-mian-wrap">
                        <div className="alignments">
                          <Avatar src={item?.profile_pic}>
                            {item?.first_name?.[0]?.toUpperCase() || 'A'}
                          </Avatar>
                        </div>
                        <div className="alignments">
                          <span className="notification-msg">{item?.activity}</span>
                          <span className="timing">{moment.utc(item?.timestamp).local().fromNow()}</span>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </div>
            <div className="pop-footer">
              <span
                onClick={() => {
                  setUnread(0)
                  props.history.push('/startup/approve/notifications')
                }}
              >
                View All
              </span>
            </div>
          </>
        ) : (
          <div className="pop-content">
            <img src={NoNotification} alt="" />
            <span className="no-notification-text">No new notifications</span>
          </div>
        )}
      </>
    </div>
  )

  return (
    <>
      <div className={props.isFeePageActive && 'disableNavbar'} />
      <div className="header-mobile m-0 justify-content-between">
        <div className="" id="home-logo">
          <img src={Logo} alt="Logo - Exitfund" />
        </div>
        <div className="d-flex justify-content-end align-items-center">
          <Popover
            arrowContent={null}
            content={notifications}
            placement="bottomRight"
            trigger="click"
            overlayClassName="approved-notifications-content-wrapper"
            onVisibleChange={visiblity => VisibleChangeHandler(visiblity)}
          >
            <Badge count={unread} onClick={() => onNotificationClick()} className="icon-bell mr-3">
              <img src={Bell} alt="Bell" />
            </Badge>
          </Popover>
          <ProfileToggle />
        </div>
      </div>
    </>
  )
}

export default withRouter(HeaderStartupApprovedMobile)
